<iframe [src]="safeUrl" width="100%" height="100%" style="overflow: hidden; border: none;"></iframe>
